import React from 'react';

const styles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '500',
  },
  primary: {
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    color: '#60a5fa',
  },
  muted: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    color: '#94a3b8',
  },
  popular: {
    position: 'absolute',
    top: '-12px',
    left: '24px',
    backgroundColor: '#3b82f6',
    color: '#fff',
    padding: '6px 16px',
    fontSize: '12px',
    fontWeight: '600',
  },
  dot: {
    width: '8px',
    height: '8px',
    backgroundColor: '#34d399',
    borderRadius: '50%',
    animation: 'pulse 2s infinite',
  },
};

export const Badge = ({
  children,
  variant = 'primary',
  showDot = false,
  style = {},
}) => {
  const badgeStyle = {
    ...styles.base,
    ...styles[variant],
    ...style,
  };

  return (
    <div style={badgeStyle}>
      {showDot && <span style={styles.dot} />}
      {children}
    </div>
  );
};
